import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from 'components';
import { PathName } from 'appConstants';
import { useSelector } from 'react-redux';
import { profileSelectors } from 'store/profile/selectors';
import styles from './styles.module.scss';

interface IFinalEventSectionProps {
  isAuthenticated: boolean;
}

const startFeatures = [
  { key: 'activation', enabled: true },
  { key: 'qualification', enabled: true },
  { key: 'team', enabled: true },
  { key: 'licenses', enabled: true },
  { key: 'participation', enabled: true },
  { key: 'eki', enabled: true },
  { key: 'freeRegistration', enabled: false },
  { key: 'noCashback', enabled: false },
];

const superFeatures = [
  { key: 'packages', enabled: true },
  { key: 'licenses', enabled: true },
  { key: 'freeQualification', enabled: true },
  { key: 'participation', enabled: true },
  { key: 'cashback', enabled: true },
  { key: 'eki', enabled: true },
  { key: 'ticket', enabled: true },
];

export const ParticipationFormatSection = ({ isAuthenticated }: IFinalEventSectionProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation('eclipseDrive');
  const { referralCode } = useSelector(profileSelectors.getState);
  
  return (
    <div className={styles.section}>
      <div className={styles.section_content}>
        <div className={styles.header}>
          <h2 className={styles.section_title}>
            {t('participation.title')}
          </h2>
          <p className={styles.section_subtitle}>
            {t('participation.subtitle')}
          </p>
        </div>
        
        <div className={styles.pricing_cards}>
          <div className={styles.pricing_card}>
            <div className={styles.card_header}>
              <h3 className={styles.card_title}>
                {t('participation.start.title')} 
                {' '}
                {t('participation.start.price')}
              </h3>
              <p className={styles.card_subtitle}>{t('participation.start.subtitle')}</p>
            </div>
            <ul className={styles.feature_list}>
              {startFeatures.map(({ key, enabled }) => (
                <li
                  key={key}
                  className={enabled ? styles.feature_item : styles.feature_item_disabled}
                >
                  {enabled ? '✓' : '✕'} 
                  {' '}
                  {t(`participation.start.features.${key}`)}
                </li>
              ))}
            </ul>
            {!isAuthenticated && (
              <Button
                type="button"
                className={styles.card_button}
                onClick={() => navigate(`${PathName.Registration}/?ref=${referralCode}`)}
              >
                {t('participation.start.cta')}
              </Button>
            )}
          </div>
          
          <div className={`${styles.pricing_card} ${styles.featured}`}>
            <div className={styles.card_header}>
              <h3 className={styles.card_title}>
                {t('participation.super.title')} 
                {' '}
                {t('participation.super.price')}
              </h3>
              <p className={styles.card_subtitle}>{t('participation.super.subtitle')}</p>
            </div>
            <ul className={styles.feature_list}>
              {superFeatures.map(({ key, enabled }) => (
                <li
                  key={key}
                  className={enabled ? styles.feature_item : styles.feature_item_disabled}
                >
                  {enabled ? '✓' : '✕'} 
                  {' '}
                  {t(`participation.super.features.${key}`)}
                </li>
              ))}
            </ul>
            {!isAuthenticated && (
              <Button
                type="button"
                className={styles.card_button}
                onClick={() => navigate(`${PathName.Registration}/?ref=${referralCode}`)}
              >
                {t('participation.super.cta')}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
